import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from '../config';
import { FaArrowLeft } from 'react-icons/fa';
import axios from "axios";


export default function ProductDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [cart, setCart] = useState([]);

  // Load cart from localStorage
  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(savedCart);
  }, []);

  // Fetch product detail
  useEffect(() => {
    axios.get(`${API_URL}/products/${id}/`)
      .then(res => setProduct(res.data))
      .catch(err => console.error(err));
  }, [id]);

  if (!product) return <p>Loading...</p>;

  const isInCart = cart.some((item) => item.id === product.id);

  const handleAddToCart = () => {
    const updatedCart = [...cart, { ...product, price: parseFloat(product.price), quantity: 1 }];
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  return (
    
    <div className="product-detail">
      <button onClick={() => navigate(-1)} className="back-button">
          <FaArrowLeft className="white-arrow" />
      </button>
      {/* 🔹 Fixed Cart Icon */}
      <div className="cart-icon" onClick={() => navigate("/cart")}>
        🛒
        {cart.length > 0 && <span className="cart-count">{cart.length}</span>}
      </div>

      <img src={product.image} alt={product.name} />
      <div className="info">
        <h1>{product.name}</h1>
        <p>{product.description}</p>
        <p className="price">₦{product.price}</p>

        {isInCart ? (
          <button className="btn added" disabled>Added</button>
        ) : (
          <button className="btn" onClick={handleAddToCart}>Add to Cart</button>
        )}
      </div>

      <style>{`
        .product-detail {
          max-width: 900px;
          margin: 40px auto;
          display: flex;
          gap: 30px;
          font-family: Arial, sans-serif;
         
          position: relative;
        }
        img {
          width: 50%;
          border-radius: 12px;
          object-fit: cover;
        }
        .info {
          flex: 1;
        }
        h1 {
          margin-bottom: 15px;
        }
        p {
          margin-bottom: 15px;
          color: #555;
        }
        .price {
          font-size: 22px;
          color: #2c7a7b;
          font-weight: bold;
          margin-bottom: 20px;
        }
        button {
          display: inline-block;
          padding: 12px 20px;
          margin: 5px 10px 5px 0;
          background: #2c7a7b;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
          transition: background 0.3s;
        }
        button:hover {
          background: #285e61;
        }
        .btn.added {
          background: #ccc;
          color: #555;
          cursor: not-allowed;
        }

        /* 🔹 Cart Icon Styles */
        .cart-icon {
          position: fixed;
          top: 200px;
          right: 20px;
          background: #2c7a7b;
          color: white;
          font-size: 24px;
          padding: 12px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cart-count {
          position: absolute;
          top: 10px;
          right: 10px;
          background: red;
          color: white;
          font-size: 14px;
          font-weight: bold;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        
      `}</style>
    </div>
  );
}
